import { getIconSvgContent as e, hasIconAsset as t, init_iconAssets as n } from "./iconAssets.es.js";
// libs/ui-lib/src/lib/customIcons.ts
n();
function r(e) {
	let t = e.match(/<svg\b[^>]*>/i);
	if (!t) return e;
	let n = t[0], r = n.replace(/\swidth\s*=\s*"[^"]*"/gi, "").replace(/\sheight\s*=\s*"[^"]*"/gi, "");
	return r = r.replace(/>$/, " width=\"100%\" height=\"100%\">"), e.replace(n, r);
}
var i = {};
function a(e, t) {
	return i[e] = {
		svgContent: t,
		name: e
	}, e;
}
function o(e) {
	let t = [];
	for (let [n, r] of Object.entries(e)) a(n, r), t.push(n);
	return t;
}
function s(n) {
	if (n in i) return i[n];
	if (t(n)) {
		let t = e(n);
		if (t) {
			let e = {
				name: n,
				svgContent: r(t),
				isAsset: !0
			};
			return i[n] = e, e;
		}
	}
}
function c(e) {
	return e in i || t(e);
}
var l = {
	logo: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5\"\n      stroke=\"currentColor\" fill=\"none\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </svg>",
	circle: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"currentColor\" />\n  </svg>",
	plus: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12 4v16m-8-8h16\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"/>\n  </svg>",
	star: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12 2l2.4 7.4H22l-6 4.4 2.3 7.1-6.3-4.5-6.3 4.5 2.3-7.1-6-4.4h7.6L12 2z\"\n      fill=\"currentColor\"/>\n  </svg>",
	heart: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z\"\n      fill=\"currentColor\"/>\n  </svg>"
};
o(l);
export { l as commonCustomIcons, s as getCustomIcon, c as hasCustomIcon, a as registerCustomIcon, o as registerCustomIcons };
